<template>
  <div>
    <RouterView name="default" :cases="allCases"></RouterView>
    <RouterView name="footer"></RouterView>
  </div>
</template>

<script>
import i18n from '@/mixins/i18n'

export default {
  name: 'App',
  mixins: [i18n],
  props: {
    locale: {
      type: String,
      default: null
    }
  },
  beforeMount () {
    this.setLocale(this.locale)
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  },
  computed: {
    allCases() {
      return this.$store.state.celebrities.all
    }
  },
  methods: {
    hasContentOverlays () {
      return this.$store.state.contentOverlays.counter > 0
    },
    activePage() {
      if(this.$route.params.url_case) {
        return `active_page`
      }

      return `inactive_page`
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.case_page_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: var(--app-bg);
}

h4 {
  color: var(--app-color-red);
}

.sharing-options__link {
  display: block;
  margin: .25rem;
  background: var(--app-color-light);
  height: 2.5em;
  line-height: 2.5em;
  width: 2.5em;
  text-align: center;
  font-size: 80%;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  position: relative;

  .svg-inline--fa {
    color: var(--app-color-black);
  }
}

</style>
